module.exports = __webpack_public_path__ + "static/img/oakville2.af8a916.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cities/oakville2.jpg
// module id = 115
// module chunks = 9